<template>
  <div class="appFooter__copyright"> © 2018 ZAPPALLAS, INC. </div>
</template>

<script>
export default {
  name: 'app-copyright'
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppCopyright.vue